import { EVENT_ADDON_ITEM_TYPE } from '../../../../constants/event-items';

/**
 * Given the set of event addon items, sort them by priority
 *
 * @param {Array} eventAddonItems the event addon items to sort
 * @returns {*[]}
 */
export const sortEventAddonItemsByPriority = eventAddonItems => {
  const priority = [
    EVENT_ADDON_ITEM_TYPE.WALDOFIED,
    EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK,
    EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO,
  ];

  return [...eventAddonItems].sort((a, b) => {
    const typeA = a.types[0] ?? a.type;
    const typeB = b.types[0] ?? b.type;
    const indexA = priority.indexOf(typeA);
    const indexB = priority.indexOf(typeB);

    if (indexA === -1 && indexB !== -1) {
      return 1;
    }

    if (indexA !== -1 && indexB === -1) {
      return -1;
    }

    return indexA - indexB;
  });
};
